import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid px-5" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col d-flex" }
const _hoisted_4 = { class: "row" }

import { ref, Ref, onMounted,nextTick } from "vue";
import OptionPageHeader from "../../components/header/OptionPageHeader.vue";
import UserUploadedFilesSection from "./section/UserUploadedFilesSection.vue";
import FileManagerPageSwitcher from "./section/FileManagerPageSwitcher.vue";
import PresetFilesSection from "./section/PresetFilesSection.vue";
import EventFilesSection from "./section/EventFilesSection.vue";
import { MessageDialog } from "../../../framework/frontend/MessageDialog";
import { translation } from "../../lang/Translation";
import { useRouter, useRoute, onBeforeRouteUpdate } from 'vue-router';
import { FileManagerPage, isFileManagerPage } from './types/FileManagerPage';
import { backToBlocklyPage } from "./functional/backToBlocklyPage";


export default /*#__PURE__*/_defineComponent({
  __name: 'FileManagerPage',
  setup(__props) {

const t = translation;
const eventCode = ref("");
const router = useRouter()
const route = useRoute()

// ページが変わった時の共通処理
const pageChangeHandler = (mode:string)=>{
  if (mode === "event") {
    eventCode.value = MessageDialog.prompt(
      t.to(`イベントコードを入力ください`, "event_code_confirm")
    );
  }
  if(!isFileManagerPage(mode)){
    MessageDialog.systemError("ページの種類にあやまりがあります。","表示時",mode);
    return;
  }
  page.value = mode;
}

// 初期表示時のページ判定
const mode = route.query.page as FileManagerPage;
// ページ変数を設定
const page:Ref<FileManagerPage> = ref(mode);
pageChangeHandler(mode);

// タブスイッチによってページが変わった時に、ページ切り替えと共にルートの変更を行う
const onPageChange = (mode: string) => {
  pageChangeHandler(mode);
  router.push({"name":"FileManagerPage",query: {"page":`${mode}`}})
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(OptionPageHeader, {
      "back-to": ()=> _unref(backToBlocklyPage)(_unref(route),_unref(router)),
      class: "px-5"
    }, null, 8, ["back-to"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(FileManagerPageSwitcher, {
            "on-change": onPageChange,
            selected: page.value
          }, null, 8, ["selected"])
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        (page.value === 'user')
          ? (_openBlock(), _createBlock(UserUploadedFilesSection, { key: 0 }))
          : _createCommentVNode("", true),
        (page.value === 'preset')
          ? (_openBlock(), _createBlock(PresetFilesSection, { key: 1 }))
          : _createCommentVNode("", true),
        (page.value === 'event')
          ? (_openBlock(), _createBlock(EventFilesSection, {
              key: 2,
              "event-code": eventCode.value
            }, null, 8, ["event-code"]))
          : _createCommentVNode("", true)
      ])
    ])
  ], 64))
}
}

})